/** GDD section 4: the view always shows at least MIN_VIEW_W × MIN_VIEW_H cells. */
export const MIN_VIEW_W = 320;
export const MIN_VIEW_H = 180;

/**
 * Largest integer scale (screen pixels per cell) that keeps the minimum view: ×4 at 1366×768, ×6 at
 * 1920×1080, ×8 at 2560×1440. Never below 1.
 */
export function viewScale(screenW: number, screenH: number): number {
  return Math.max(1, Math.min(Math.floor(screenW / MIN_VIEW_W), Math.floor(screenH / MIN_VIEW_H)));
}
